import { render, staticRenderFns } from "./TwoDGeneration.vue?vue&type=template&id=7e2b4a52&scoped=true"
import script from "./TwoDGeneration.vue?vue&type=script&lang=js"
export * from "./TwoDGeneration.vue?vue&type=script&lang=js"
import style0 from "./TwoDGeneration.vue?vue&type=style&index=0&id=7e2b4a52&prod&lang=css"
import style1 from "./TwoDGeneration.vue?vue&type=style&index=1&id=7e2b4a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2b4a52",
  null
  
)

export default component.exports